/* eslint-disable @typescript-eslint/no-explicit-any */
import { Button, Card, Form, Tag } from "antd";
import IconCrewWork from "../../../../../atoms/CustomIcons/IconCrewWork";
// import { ClockCircleOutlined } from "@ant-design/icons";
// import { InputNumberField } from "../../../../../atoms/FormFields";
import { useForm } from "react-hook-form";
import { TimePickerField } from "../../../../../atoms/FormFields/TimePickerField";
import { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../../../../config/hooks";
import { getCompanyFieldsById } from "../../../TagsCategories/ducks/actions";
import { updateCompanySettings } from "../../ducks/services";
import { SuccessMessage } from "../../../../../atoms/Toasts/SuccessMessage";
import { AxiosError } from "axios";
import { ErrorMessage } from "../../../../../atoms/Toasts/ErrorMessage";
import dayjs from "dayjs";
import SpecifyEffectiveDatePopup from "../ProposalsAndContracts/SpecifyEffectiveDatePopup";
import { PopUp } from "../../../../../atoms/PopUp";
import { InputNumberField } from "../../../../../atoms/FormFields";

export default function CrewWorkSchedule({
  setLoading,
}: {
  setLoading: (loading: boolean) => void;
}) {
  const { control, handleSubmit, setValue } = useForm();
  const [selectedTags, setSelectedTags] = useState<string[]>([
    "Mon",
    "Tue",
    "Wed",
    "Thu",
    "Fri",
  ]);
  const tagsData = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];

  const dispatch = useAppDispatch();
  const location = window.location.pathname;
  const pathSegments = location.split("/");
  const companyId = pathSegments[pathSegments.length - 1];
  const serviceLineId = pathSegments[pathSegments.length - 2];

  const [isEffectiveDateModalOpen, setIsEffectiveDateModalOpen] =
    useState(false);

  const specifyEffectiveDate = {
    visibility: isEffectiveDateModalOpen,
    content: (
      <SpecifyEffectiveDatePopup
        title=""
        onClose={() => setIsEffectiveDateModalOpen(false)}
        heading="Specify effective date"
        paragraph="Set the date when the changes take effect. Data before that date will remain unchanged."
        btnText="Confirm"
        btnApi={() => null}
        loading={false}
      />
    ),
    width: 540,
    onCancel: () => setIsEffectiveDateModalOpen(false),
  };

  const settingsData = useAppSelector((state) => state?.tags?.tagData);

  useEffect(() => {
    if (companyId && serviceLineId) {
      const payload = {
        company_id: companyId,
        service_line_id: serviceLineId,
        module: "CREW_WORK_SCHEDULE",
      };

      dispatch(getCompanyFieldsById(payload));
    }
  }, [dispatch, companyId, serviceLineId]);

  useEffect(() => {
    if (settingsData) {
      const weekHours: any = settingsData?.data?.find(
        (item: { name: string; value: string }) =>
          item?.name === "MAX_WORK_HOURS_PER_WEEK"
      );
      const listDays: any = settingsData?.data?.find(
        (item: { name: string; value: string }) =>
          item?.name === "LIST_OF_WORKING_DAYS"
      );
      const shiftStartTime: any = settingsData?.data?.find(
        (item: { name: string; value: string }) =>
          item?.name === "SHIFT_START_TIME"
      );
      const dayStartCrewYardDuration: any = settingsData?.data?.find(
        (item: { name: string; value: string }) =>
          item?.name === "DAY_START_CREW_YARD_DURATION"
      );
      const dayEndCrewYardDuration: any = settingsData?.data?.find(
        (item: { name: string; value: string }) =>
          item?.name === "DAY_END_CREW_YARD_DURATION"
      );

      if (weekHours) {
        setValue("MAX_WORK_HOURS_PER_WEEK", Number(weekHours?.value));
      }

      if (listDays) {
        setSelectedTags(JSON?.parse(listDays?.value) || []);
      }
      if (shiftStartTime) {
        setValue("SHIFT_START_TIME", dayjs(shiftStartTime?.value, "HH:mm"));
      }
      if (dayStartCrewYardDuration) {
        setValue(
          "DAY_START_CREW_YARD_DURATION",
          Number(dayStartCrewYardDuration?.value)
        );
      }
      if (dayEndCrewYardDuration) {
        setValue(
          "DAY_END_CREW_YARD_DURATION",
          Number(dayEndCrewYardDuration?.value)
        );
      }
    }
  }, [settingsData, setValue]);

  const onSubmit = (data: any) => {
    console.log("Form Data:", data);

    setLoading(true);
    const payload = [];

    if (data.MAX_WORK_HOURS_PER_WEEK) {
      payload.push({
        company_id: companyId,
        service_line_id: serviceLineId,
        module: "CREW_WORK_SCHEDULE",
        name: "MAX_WORK_HOURS_PER_WEEK",
        value: data.MAX_WORK_HOURS_PER_WEEK.toString(),
      });
    }

    if (selectedTags) {
      payload.push({
        company_id: companyId,
        service_line_id: serviceLineId,
        module: "CREW_WORK_SCHEDULE",
        name: "LIST_OF_WORKING_DAYS",
        value: JSON.stringify(selectedTags),
      });
    }
    if (data.SHIFT_START_TIME) {
      payload.push({
        company_id: companyId,
        service_line_id: serviceLineId,
        module: "CREW_WORK_SCHEDULE",
        name: "SHIFT_START_TIME",
        value: dayjs(data.SHIFT_START_TIME).format("HH:mm"),
      });
    }
    if (data.DAY_START_CREW_YARD_DURATION) {
      payload.push({
        company_id: companyId,
        service_line_id: serviceLineId,
        module: "CREW_WORK_SCHEDULE",
        name: "DAY_START_CREW_YARD_DURATION",
        value: data.DAY_START_CREW_YARD_DURATION?.toString(),
      });
    }
    if (data.DAY_END_CREW_YARD_DURATION) {
      payload.push({
        company_id: companyId,
        service_line_id: serviceLineId,
        module: "CREW_WORK_SCHEDULE",
        name: "DAY_END_CREW_YARD_DURATION",
        value: data.DAY_END_CREW_YARD_DURATION?.toString(),
      });
    }

    updateCompanySettings(payload)
      .then(() => {
        setLoading(false);
        SuccessMessage("Changes saved");
      })
      .catch((e: unknown) => {
        if (e instanceof AxiosError) {
          setLoading(false);
          ErrorMessage(
            e?.response?.data?.error?.message ?? "Something went wrong"
          );
        } else {
          setLoading(false);
          ErrorMessage("Something went wrong");
        }
      });
  };

  const handleChange = (tag: string, checked: boolean) => {
    const nextSelectedTags = checked
      ? [...selectedTags, tag]
      : selectedTags.filter((t) => t !== tag);
    console.log("You are interested in: ", nextSelectedTags);
    setSelectedTags(nextSelectedTags);
  };

  return (
    <div style={{ width: "800px", margin: "0 auto" }}>
      <div>
        <h2 className="tabs_content_heading">
          <IconCrewWork /> Crew work schedule
        </h2>
        <p className="tabs_content_subheading">
          Configure working times and days for the crews and technicians.
        </p>
      </div>

      <Form
        layout="vertical"
        onFinish={handleSubmit(onSubmit)}
        onKeyDown={(e) => {
          if (e.key === "Enter") e.preventDefault();
        }}
      >
        {/* <Card className="cs_management_card">
          <div className="cs_title_bar">
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                gap: "16px",
              }}
            >
              <div className="icon_avatar">
                <img
                  src="/images/settings/cs_hours.svg"
                  alt="customer management"
                />
              </div>
              <div>
                <h3> Working hours allowance </h3>
                <p>
                  Set the max number of hours per employee. This includes direct
                  and indirect time. Everything extra will be considered as
                  overtime.
                </p>
              </div>
              <Button
                htmlType="button"
                className="outlined-btn"
                type="primary"
                style={{ padding: "11px" }}
              >
                <ClockCircleOutlined />
              </Button>
            </div>
          </div>
          <div className="bordered_card" style={{ marginBottom: "12px" }}>
            <h4 style={{ marginBottom: "6px" }}> Daily target </h4>
            <p style={{ color: "#6C7478" }}>
              Set standard working hours per day.
            </p>
          </div>

          <div className="grey_box">
            <h4 style={{ marginBottom: "6px" }}> Weekly target </h4>
            <p style={{ color: "#6C7478", marginBottom: "14px" }}>
              Set standard working hours per week.
            </p>
            <div style={{ maxWidth: "317px" }}>
              <InputNumberField
                fieldName="MAX_WORK_HOURS_PER_WEEK"
                label="Hours per week"
                control={control}
                defaultValue={0}
                iProps={{
                  placeholder: "Hours per week",
                  min: 1,
                }}
                isRequired
                rules={{
                  required: "This field is required.",
                }}
              />
            </div>
          </div>
        </Card> */}

        <Card className="cs_management_card">
          <div className="cs_title_bar">
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                gap: "16px",
              }}
            >
              <div className="icon_avatar">
                <img
                  src="/images/settings/icon_schedule.svg"
                  alt="customer management"
                />
              </div>
              <div>
                <h3> Working days </h3>
                <p>
                  Select the default working days. To mark a specific day as a
                  work day or a day off later, use the scheduling board.
                </p>
              </div>
            </div>
          </div>

          <div className="weekTags">
            {tagsData.map<React.ReactNode>((tag) => (
              <Tag.CheckableTag
                key={tag}
                checked={selectedTags.includes(tag)}
                onChange={(checked) => handleChange(tag, checked)}
              >
                {tag}
              </Tag.CheckableTag>
            ))}
            {/* <Tag className="grey_tag">
              Mon <CloseOutlined />
            </Tag>
            <Tag className="grey_tag">
              Tue <CloseOutlined />
            </Tag>
            <Tag className="grey_tag">
              Wed <CloseOutlined />
            </Tag>
            <Tag className="grey_tag">
              Thu <CloseOutlined />
            </Tag>
            <Tag className="grey_tag">
              Fri <CloseOutlined />
            </Tag>
            <Tag className="outlined_tag">Sat</Tag>
            <Tag className="outlined_tag">Sun</Tag> */}
            {/* <h6
              style={{
                color: "#007F61",
                fontSize: "14px",
                fontWeight: "400",
                cursor: "pointer",
              }}
              onClick={() => setIsEffectiveDateModalOpen(true)}
            >
              Effective
              <span style={{ fontWeight: "600" }}> September 20 </span>
            </h6> */}
          </div>
        </Card>

        <Card className="cs_management_card">
          <div className="cs_title_bar">
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                gap: "16px",
              }}
            >
              <div className="icon_avatar">
                <img
                  src="/images/settings/cs_hours.svg"
                  alt="customer management"
                />
              </div>
              <div>
                <h3> Shift start time </h3>
                <p>Set when crews and technicians punch in for the day.</p>
              </div>
            </div>
          </div>

          <div className="weekTags">
            <div style={{ width: "317px" }}>
              <TimePickerField
                fieldName="SHIFT_START_TIME"
                label="Shift start time"
                control={control}
                iProps={{
                  placeholder: "Shift start time",
                  min: 1,
                }}
                isRequired
                rules={{
                  required: "This field is required.",
                }}
              />
            </div>
            {/* <h6
              style={{
                color: "#007F61",
                fontSize: "14px",
                fontWeight: "400",
                cursor: "pointer",
              }}
              onClick={() => setIsEffectiveDateModalOpen(true)}
            >
              Effective
              <span style={{ fontWeight: "600" }}> September 20 </span>
            </h6> */}
          </div>
        </Card>

        <Card className="cs_management_card">
          <div className="cs_title_bar">
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                gap: "16px",
              }}
            >
              <div className="icon_avatar">
                <img
                  src="/images/settings/icon_home.svg"
                  alt="customer management"
                />
              </div>
              <div>
                <h3> Time allocated to crew yards </h3>
                <p>
                  Indirect time at the start and end of the day for crews to
                  gather and complete standard procedures before departure and
                  after return.
                </p>
              </div>
            </div>
          </div>

          <div className="weekTags">
            <div style={{ width: "250px" }}>
              <InputNumberField
                fieldName="DAY_START_CREW_YARD_DURATION"
                label="Beginning of the day"
                control={control}
                iProps={{
                  placeholder: "Beginning of the day",
                  min: 1,
                  suffix: "mins",
                  control: false,
                }}
                isRequired
                rules={{
                  required: "This field is required.",
                }}
              />
            </div>
            <div style={{ width: "250px" }}>
              <InputNumberField
                fieldName="DAY_END_CREW_YARD_DURATION"
                label="End of the day"
                control={control}
                iProps={{
                  placeholder: "End of the day",
                  min: 1,
                  suffix: "mins",
                  control: false,
                }}
                isRequired
                rules={{
                  required: "This field is required.",
                }}
              />
            </div>
            {/* <h6
              style={{
                color: "#007F61",
                fontSize: "14px",
                fontWeight: "400",
                cursor: "pointer",
              }}
              onClick={() => setIsEffectiveDateModalOpen(true)}
            >
              Effective
              <span style={{ fontWeight: "600" }}> September 20 </span>
            </h6> */}
          </div>
        </Card>

        <div style={{ textAlign: "right", width: "100%" }}>
          <Button
            htmlType="submit"
            className="mint-btn"
            style={{ marginTop: "10px" }}
          >
            Save changes
          </Button>
        </div>
      </Form>

      <PopUp {...specifyEffectiveDate} />
    </div>
  );
}
